module.exports = __webpack_public_path__ + "static/media/Leslaw Janus.fd9cd74d.png";